/**
 * @fileoverview Barrel exports for the extract-styleguide-v2 COMPOSITE agent.
 *
 * This is a composite agent that orchestrates three primitives:
 * - genre-detector-v2: Detects genres from text
 * - style-analyzer-v2: Analyzes style to get slider values
 * - generate-custom-style-guide-v2: Generates the final style guide
 *
 * Structure:
 * - definition.ts: Agent metadata with composite configuration
 * - schema.ts: Input/output Zod schemas
 * - prompt.ts: Handlebars prompt template (for genre detection step)
 * - flow.ts: Orchestration logic for the three primitives
 */

// Agent definition
export { definition } from './definition';

// Schemas and types
export {
  InputSchema,
  OutputSchema,
  GenreDetectionOutputSchema,
  type Input,
  type Output,
  type HookInput,
  type GenreDetectionOutput,
} from './schema';

// Flow
export { flow, extractStyleguideV2AgentFlow } from './flow';

